import { FC, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  List,
} from "@mui/material";
import { UsersWhoParticipantsOfEventDto } from "@app/data/tribeSwaggerApi";
import { DialogItem } from "@components/Dialogs/ParticipantsListDialog/DialogItem";
import { SlideUp } from "@components/Transition";
import useScreenSize from "@utils/useScreenSize";
import { DialogAppBar } from "@components/Dialogs/ParticipantsListDialog/DialogAppBar";
import { lockScroll, unlockScroll } from "@utils/scroll.utils";

export interface ParticipantsListDialogProps {
  open: boolean;
  onClose: () => void;
  participants: UsersWhoParticipantsOfEventDto[]
}
const ParticipantsListDialog: FC<ParticipantsListDialogProps> = ({ open, onClose, participants}) => {
  const screenSize = useScreenSize()
  const  isMobile = screenSize === "mobile"
  useEffect(() => {
    if (open) {
      lockScroll();
    } else {
      unlockScroll();
    }
  }, [open]);
  return  <Dialog
    fullScreen={isMobile}
    onClose={onClose}
    open={open}
    TransitionComponent={SlideUp}
  >
    {isMobile && <DialogAppBar onClose={onClose}/>}
    <DialogContent>
      <List>
        {participants.map((participant) => <DialogItem key={participant.participant_id} model={participant} />)}
      </List>
    </DialogContent>
  </Dialog>
}
export default ParticipantsListDialog